var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signin-history"},[_c('v-data-table',{attrs:{"server-items-length":_vm.getTotalItems,"headers":_vm.headers,"items":_vm.items,"items-per-page":_vm.itemsPerPage,"footer-props":{
      itemsPerPageOptions: [_vm.itemsPerPage]
    }},on:{"update:page":_vm.pageChanged},scopedSlots:_vm._u([{key:"item.customer",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(item.user.customer.name)+" ")]}},{key:"item.user",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(item.user.email)+" ")]}},{key:"item.timestamp",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(item.timestamp)+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }